import React from 'react'

import Page from '../page'

import ArticleComponent from '../components/post/single'
import SEO from '../components/seo'

class ArticleSinglePost extends Page {
  onMountGlobalState(state) {
    return {
      ...state,
      whiteLogo: false,
    }
  }

  render() {
    return [
      <SEO
        {...this.props.data.article}
        {...this.props.pathContext}
        key="seo"
      />,
      <ArticleComponent
        data={this.props.data}
        {...this.props.pathContext}
        key="page"
      />,
    ]
  }
}

export default ArticleSinglePost

export const pageQuery = graphql`
  query currentArticleQuery($id: String!, $lang: String!) {
    article: wordpressPost(id: { eq: $id }) {
      ...PostSingleFragment
    }
    monthlyArchives: allWordpressPostArchive(filter: { lang: { eq: $lang } }) {
      edges {
        node {
          year
          month
          slug
          count
          link
        }
      }
    }
    relatedArchives: allWordpressPost(
      limit: 2
      filter: { id: { ne: $id }, lang: { eq: $lang } }
    ) {
      edges {
        node {
          ...PostExcerptFragment
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-single.js